import '../utils/fix.cross-origin'
/**
 * @createdBy:HuangJian
 * @date:2019/1/3
 * @description：主题样式名混入
 */
export default {
    computed: {
        themeClass(){
            return window.CURRENT_ORIGIN_TOP.appCtx && window.CURRENT_ORIGIN_TOP.appCtx.appName === 'CRM'? 'crm-color' : 'dms-color';
        }
    }
};
